import React, { useState, createRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { IconButton, Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import { getValue, setValueWithExpire } from '../../utils/localStorage';
import { findIndex } from '../../utils/lodash';
import renderHTML from 'react-render-html';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  quotesExpandedRoot: {
    width: 'calc(100% - 360px)'
  },
  alert: {
    backgroundColor: `${theme.palette.secondary[900]} !important`,
    borderRadius: '0 !important',
    color: `${theme.palette.secondary.main} !important`,
    padding: `${theme.spacing(0, 4.5)} !important`,
    borderTop: '1px dashed #bbb !important',
    '&:first-child': {
      borderTop: 'none !important'
    },
    '& a': {
      color: 'white !important'
    }
  },
  dismissAlert: {
    opacity: 0.4
  },
  nonDismissAlert: {
    opacity: 0.8
  }
}));

const CloseButton = props => {
  const { onClose } = props;
  return (
    <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
      <CloseIcon fontSize="inherit" />
    </IconButton>
  );
};

const BannerAlert = props => {
  const classes = useStyles();
  const [ bannerNotice, updateBannerNotice ] = useState(props.bannerNotice || []);
  const handleOnClose = noticeId => {
    setValueWithExpire(`notice-${noticeId}`, true, { expires: 365, path: '/' });
    const noticeIndex = findIndex(bannerNotice, notice => notice.id === noticeId);
    if (noticeIndex > -1) {
      const data = bannerNotice;
      data.splice(noticeIndex, 1);
      updateBannerNotice([ ...data ]);
    }
  };
  const { setNoticeHeight = () => {}, isQuotesExpanded } = props;
  const noticeRef = createRef();
  useEffect(
    () => {
      setNoticeHeight(noticeRef.current.offsetHeight);
    },
    [ noticeRef, setNoticeHeight ]
  );
  return (
    <div className={clsx(classes.root, isQuotesExpanded && classes.quotesExpandedRoot)} ref={noticeRef}>
      {bannerNotice.map(notice => {
        const { id, dismissable = false, message = '' } = notice;
        const isDismissedNotice = getValue(`notice-${id}`);
        if (isDismissedNotice) {
          return <React.Fragment key={id} />;
        } else {
          const props = dismissable ? { action: <CloseButton onClose={() => handleOnClose(id)} /> } : {};
          const additionalClass = dismissable ? classes.dismissAlert : classes.nonDismissAlert;
          return (
            <Alert
              key={id}
              variant="filled"
              severity="error"
              className={clsx(classes.alert, additionalClass)}
              {...props}
            >
              <Box>{renderHTML(message)}</Box>
            </Alert>
          );
        }
      })}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({});
const mapStateToProps = state => ({
  isQuotesExpanded: state.leadPreferenceReducer.isQuotesExpanded
});

export default connect(mapStateToProps, mapDispatchToProps)(BannerAlert);
